<template>
	<div>
		<HeroEvent v-if="hero" :data="hero"/>

		<template v-if="page">
			<template v-for="(entry, index) in page.sections" :key="index">
				<component :is="entry.__typename.replace('_Entry', '')" :data="entry"/>
			</template>

			<div class="component" v-if="page.sections.length == 0"></div>
		</template>
	</div>
</template>

<script setup>
import { eventQuery } from '@/api/queries'
import { onMounted } from 'vue';
const config = useRuntimeConfig();
const route = useRoute();

const page = ref(null)
const hero = ref(null)

const query = eventQuery(route.params.slug[0])
const token = route.query.token;

const getData = async () => {
	const { data: gql } = await useFetch(config.public.API, {
		params: { query, token },
	});

	if (gql.value) {
		page.value = gql.value.data.eventsEntries[0];

		hero.value = {
            title: page.value.title,
            dateFrom: page.value.dateFrom,
            dateTo: page.value.dateTo,
            media: page.value.media[0],
            ticketLink: page.value.ticketLink
        }

		console.log('hero:.:: ', page.value)
	}
};

await getData();

onMounted(() => {
	// if (!page.value) {
		getData();
	// }
})

useHead({
	title: `Sydhavn Teater — ${page?.value?.title}`,
	meta: [
		{ hid: 'og:title', property: 'og:title', content: `Sydhavn Teater — ${page?.value?.title}` },
		{ hid: 'og:image', property: 'og:image', content: page?.value?.media[0]?.url },
	],
});
</script>